module.exports = __webpack_public_path__ + "img/neudorf-main.d7c18790.jpg";